module.exports = __webpack_public_path__ + "static/media/payer-confirm.03e15e51.svg";